<template>
	<modal name="edit-song" :width="width" height="auto" :pivot-y="0" :pivot-x="1" :click-to-close="false" :reset="true">
		<div id="edit-song-modal" :class="{ 'night-mode': nightMode }">
			<input type="text" v-model="title">
			<input type="text" v-model="author">
			<textarea name="song-edit-textarea" v-model="content" :style="{ height: textareaHeight }"></textarea>
			<button type="button" class="confirm" @click="confirm">{{ $t('song.saveChanges') }}</button>
			<button type="button" class="cancel" @click="cancel">{{ $t('song.cancelButton') }}</button>
		</div>
	</modal>
</template>

<script>
	import { SongService } from "@/services/SongService";
	import { mapState } from "vuex";

	export default {
		data() {
			return {
			}
		},
		computed: {
			...mapState([ "currentSong", "nightMode" ]),
			content: {
				get() {
					return this.currentSong.content;
				},
				set(content) {
					this.$store.commit("setCurrentSongContent", content);
				}
			},
			title: {
				get() {
					return this.currentSong.title;
				},
				set(title) {
					this.$store.commit("setCurrentSongTitle", title);
				}
			},
			author: {
				get() {
					return this.currentSong.author;
				},
				set(author) {
					this.$store.commit("setCurrentSongAuthor", author);
				}
			}
		},
		recomputed: {
			width() {
				const windowWidth = window.innerWidth;
				return windowWidth > 500 ? 500 : windowWidth;
			},
			textareaHeight() {
				const windowHeight = window.innerHeight;
				return (windowHeight - 237).toString() + "px";
			}
		},
		created() {
			window.addEventListener("resize", this.onResize);
		},
		destroyed() {
			window.removeEventListener("resize", this.onResize);
		},
		methods: {
			onResize() {
				this.$recompute("width");
				this.$recompute("textareaHeight");
			},
			confirm() {
				SongService.setSongContentAndTitleAndAuthor(this.currentSong);
				this.$modal.hide("edit-song");
			},
			cancel() {
				this.$modal.hide("edit-song");
			}
		}
	}
</script>

<style lang="scss" scoped>
	#edit-song-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		&.night-mode {
			textarea, input {
				background-color: rgba(72, 106, 121, 0.63);
				color: rgba(255, 255, 255, 0.81);
			}
		}

		button {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			font-weight: 300;
			border: 0;
			margin: 5px 0 0 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}
		}

		input {
			margin: 5px 5px 0 5px;
			font-size: 1em;
			width: 97%;
			border-radius: 4px;
			border: 1px solid rgba(0, 0, 0, 0.2);
			background-color: white;
			padding: 10px;
			line-height: 1.4em;
			box-sizing: border-box;

			&:focus {
				outline: none;
			}
		}

		textarea {
			margin: 5px 5px 0 5px;
			font-size: 0.85em;
			width: 97%;
			border-radius: 4px;
			border: 1px solid rgba(0, 0, 0, 0.2);
			background-color: white;
			padding: 10px;
			line-height: 1.4em;
			box-sizing: border-box;

			&:focus {
				outline: none;
			}
		}

		button.confirm {
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			color: rgba(255, 255, 255, 0.8);
		}

		button.cancel {
			background: rgb(164, 164, 164);
			color: rgba(0, 0, 0, 0.71);
		}

	}
</style>
